/**
 * Collection Order Popup Component
 * 
 * Handles the popup form functionality for collection item orders
 * 
 * @package Chorna_Jewelry
 * @since 1.0.0
 */

/**
 * Initialize collection order popup functionality
 */
export function initCollectionOrderPopup() {
    const $orderButton = document.querySelector('.collection-order-button');
    const $popup = document.getElementById('collection-order-popup');
    
    if (!$orderButton || !$popup) {
        return;
    }

    const $overlay = $popup.querySelector('.collection-order-popup-overlay');
    const $closeButton = $popup.querySelector('.collection-order-popup-close');
    const $popupBody = $popup.querySelector('.collection-order-popup-body');
    const $body = document.body;
    let originalContent = null;

    // Prevent page reload on form submit - prevent default but let CF7 handle AJAX
    $popup.addEventListener('submit', function(e) {
        const form = e.target;
        if (form.tagName === 'FORM' && form.classList.contains('wpcf7-form')) {
            e.preventDefault();
            // Don't stop propagation - let CF7 handle the submission
        }
    }, true);

    // Open popup
    $orderButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Store original content if not already stored
        if (!originalContent && $popupBody) {
            originalContent = $popupBody.innerHTML;
        }
        
        // Restore original content
        if (originalContent && $popupBody) {
            $popupBody.innerHTML = originalContent;
            
            // Reinitialize Contact Form 7 after content is restored
            if (window.wpcf7 && typeof window.wpcf7.init === 'function') {
                const $form = $popupBody.querySelector('form.wpcf7-form');
                if ($form) {
                    window.wpcf7.init($form);
                }
            }
        }
        
        const itemId = this.getAttribute('data-collection-item-id');
        const itemLink = this.getAttribute('data-collection-item-link');
        const itemTitle = this.getAttribute('data-collection-item-title');
        
        // Show popup first
        $popup.style.display = 'flex';
        $body.style.overflow = 'hidden';
        
        // Set hidden field values
        const itemIdField = $popup.querySelector('input[name="collection-item-id"]');
        const itemLinkField = $popup.querySelector('input[name="collection-item-link"]');
        const itemTitleField = $popup.querySelector('input[name="collection-item-title"]');
        
        if (itemIdField) itemIdField.value = itemId ?? '';
        if (itemLinkField) itemLinkField.value = itemLink ?? '';
        if (itemTitleField) itemTitleField.value = itemTitle ?? '';
    });

    // Close popup function
    function closePopup() {
        $popup.style.display = 'none';
        $body.style.overflow = '';
    }

    // Close on close button click
    if ($closeButton) {
        $closeButton.addEventListener('click', closePopup);
    }

    // Close on overlay click
    if ($overlay) {
        $overlay.addEventListener('click', closePopup);
    }

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && $popup.style.display === 'flex') {
            closePopup();
        }
    });

    // Replace modal content with success message after successful form submission
    document.addEventListener('wpcf7mailsent', function(event) {
        const form = event.target;
        if (!$popup || !$popup.contains(form)) {
            return;
        }
        
        if ($popupBody) {
            $popupBody.innerHTML = '<p class="wpcf7-response-output wpcf7-mail-sent-ok">' + 
                (event.detail?.apiResponse?.message || 'Дякуємо! Ваше замовлення надіслано.') + 
                '</p>';
        }
    }, false);
}

